var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('vue-page-transition',{staticStyle:{"height":"100%"}},[_c('router-view')],1),_c('loading-overlay'),_c('custom-snackbar'),_c('confirm'),_c('reason-prompt'),(_vm.userId)?_c('support-chat-heads'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }